import { render, staticRenderFns } from "./passageLog.vue?vue&type=template&id=2bc66216&scoped=true"
import script from "./passageLog.vue?vue&type=script&lang=js"
export * from "./passageLog.vue?vue&type=script&lang=js"
import style0 from "./passageLog.vue?vue&type=style&index=0&id=2bc66216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc66216",
  null
  
)

export default component.exports